import React from 'react';
import styles from './style/modalContent.module.css';

const ModalContent = ({ children }:{ children:React.ReactNode }) => (
  <div className={styles.modalContent}>
    { children }
  </div>
);

export default ModalContent;
